module.exports = __webpack_public_path__ + "static/media/error.4a301fe2.png";